import { IWorkHoursItem } from "../workTime/workHoursItem";

export interface WorkHourSaveData {
    employeeIds: string[];
    salaryPeriodId: string;
    workHours: WorkHourSaveItem[];
    workShiftTimeSlotIds: string[];
}

export interface WorkHourSaveItem {
    employeeId: string;
    category: string;
    salaryRowTypeId?: string;
    workOrderId?: string;
    costCenterId?: string;
    customerId?: string;
    vehicleId?: string;
    workShiftId?: string;
    workShiftTimeSlotId?: string;
    dayBookingId?: string;
    workTimeTypeId?: string;
    date: string;
    amount: number;
    dayHoursRatio?: number;
    comment?: string;
    startTime?: string;
    endTime?: string;
}

export const getWorkHourSaveItem = ({
    employeeId,
    category,
    salaryRowTypeId,
    workOrderId,
    costCenterId,
    customerId,
    vehicleId,
    workShiftId,
    workShiftTimeSlotId,
    dayBookingId,
    workTimeTypeId,
    dateStr,
    amount,
    dayHoursRatio,
    comment,
    startTime,
    endTime,
}: IWorkHoursItem): WorkHourSaveItem => ({
    employeeId,
    category,
    salaryRowTypeId,
    workOrderId,
    costCenterId,
    customerId,
    vehicleId,
    workShiftId,
    workShiftTimeSlotId,
    dayBookingId,
    workTimeTypeId,
    date: dateStr,
    amount,
    dayHoursRatio,
    comment,
    startTime,
    endTime,
});
